import { render, staticRenderFns } from "./LeadForm.vue?vue&type=template&id=640dd0ce&scoped=true&lang=html"
import script from "./LeadForm.vue?vue&type=script&lang=js"
export * from "./LeadForm.vue?vue&type=script&lang=js"
import style0 from "./LeadForm.vue?vue&type=style&index=0&id=640dd0ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "640dd0ce",
  null
  
)

export default component.exports